import React from 'react';
import Navbar from './Navbar';
import Quote from './Quote';

const QuotePage = () => (
  <div>
    <Navbar />
    <main>
      <Quote />
    </main>
  </div>
);

export default QuotePage;
